import {checkSectionVisibility} from '../Common/checkSectionVisibility';

export function populateBenefits(jsonData){

    var benefitHeadingText = jsonData.benefits.section_heading.value;
    var mainBenefitsMaximum = jsonData.benefits.data.main_benefits.maximum;
    // var simpleBenefitsMaximum = jsonData.benefits.data.other_benefits.maximum;
    var simpleBenefitsMaximum = 51;

    var showMoreContainer = $(".show-more-container.benefits");   
    var showMoreButton = showMoreContainer.find("button");

    if(!$(document).find(".preview").hasClass("hidden")){
        $("#benefitHeadingText").html(benefitHeadingText);        
    }
    else{           
        checkSectionVisibility(jsonData.benefits.visibility, $(".perks"));                 
        $("input#benefitHeadingText").val(benefitHeadingText);
    }
    
    function getBenefits() {
        var benefit = $(".perks__descriptive-perks-container").find('.perks__col.prototype.hidden').clone().removeClass('prototype hidden');
        benefit.addClass("benefit")
        return {
            element: benefit,
            title: benefit.find(".perks-title"),
            description: benefit.find(".perks-description"),
            logo: benefit.find(".perks-icons").find("i"),
        }
    }

    function getSimpleBenefits() {
        var benefitSimple = $(".perks__simple-perks-container").find('.perks__col.prototype.hidden').clone().removeClass('prototype hidden');
        benefitSimple.addClass("benefitSimple")
        return {
            element: benefitSimple,
            title: benefitSimple.find(".perks-title"),
            logo: benefitSimple.find(".perks-icons").find("i"),
        }
    }

    var count = 0;
    var othersCount = 0
    function populateData(jsonData){
        
        $.each(jsonData.benefits.data.main_benefits.content, function(index, Item) {
            if(count<mainBenefitsMaximum){                
                var newBenefit = getBenefits();
                if(!$(document).find(".preview").hasClass("hidden")){
                    newBenefit.title.html(Item.title);
                    newBenefit.description.html(Item.description);                    
                }
                else{                                        
                    newBenefit.title.val(Item.title);
                    newBenefit.description.val(Item.description);
                    if(count>=3){
                        newBenefit.element.find(".removeBenefit").removeClass("hidden");
                    }
                }
                newBenefit.logo.removeAttr("class");
                newBenefit.logo.addClass(Item.logo);
                newBenefit.element.css("display", "inline-block");

                
                $('.perks__descriptive-perks-container').find(".perks__row").append(newBenefit.element);
                if(count>5){
                    if($(document).width() > 767){
                        resizeBenefitWidth();
                    }
                    // count++;
                }
                else{
                    if(count == 3){
                        $('.perks__descriptive-perks-container').find(".perks__row").css("text-align", "center");
                    }
                    else{
                        $(".perks__col.benefit:nth-child(5n)").css("border-right","1px solid #f2e9dd");
                        $('.perks__descriptive-perks-container').find(".perks__row").css("text-align", "left");
                    }
                    
                }
                
                count++;
                if(count>3){
                    $(".perks__col.benefit:lt(3)").css("border-bottom","1px solid #f2e9dd");
                    // $(".perks__container").find(".show-more-container.benefits").css("margin-top", "0px");
                    // $(".perks__container").find(".add-other-benefits").css("margin-top", "20px");
                }
            }
        });

        if(jsonData.benefits.data.other_benefits.content.length){
            // $(".perks__descriptive-perks-container").find(".perks__row").css("border-bottom", "1px solid #f2e9dd");
            // $(".perks__container").find(".show-more-container.benefits").removeClass("hidden");
            // $(".perks__container").find(".show-more-container.benefits").css("padding-bottom", "50px");
            
            populateSimpleData(jsonData);
            if(!$(document).find(".preview").hasClass("hidden")){
                showMoreBenefits();               
            }
            else{
                // remove hidden from simple container in edit mode only 
                $(".perks__container").find(".perks__simple-perks-container").removeClass("hidden");

            } 
        }
    }  
    
    
    
    var maxSimpleBenefits = simpleBenefitsMaximum + mainBenefitsMaximum;
    function populateSimpleData(jsonData){
        $.each(jsonData.benefits.data.other_benefits.content, function(index, Item) {
                        
            if(othersCount< simpleBenefitsMaximum){
                var newBenefit = getSimpleBenefits();
                newBenefit.title.html(Item.title);
                newBenefit.logo.removeAttr("class");
                newBenefit.logo.addClass(Item.logo);

                if(!$(document).find(".preview").hasClass("hidden")){
                    newBenefit.element.addClass("moreBenefit hidden");                    
                }

                newBenefit.element.css("display", "inline-block");
                $('.perks__simple-perks-container').find(".perks__row").append(newBenefit.element);
                
                othersCount++;                
            }
        });
        // console.log("after simple data",count);
        
    }

    function addDynamicBenefit(){
        var newBenefit = getBenefits();
        newBenefit.element.css("display", "inline-block");
        newBenefit.element.find(".removeBenefit").removeClass("hidden");
        $('.perks__descriptive-perks-container').find(".perks__row").append(newBenefit.element); 
        newBenefit.element.css("background-color", "#cbe4ff");
        window.setTimeout(function(){
            newBenefit.element.css("background-color", "initial"); 
        }, 1000);      
    }

    function addDynamicSimpleBenefit(){
        if(count< maxSimpleBenefits){
            var newBenefit = getSimpleBenefits();
            newBenefit.element.css("display", "inline-block");
            $('.perks__simple-perks-container').find(".perks__row").append(newBenefit.element);
            newBenefit.element.css("background-color", "#cbe4ff");
            window.setTimeout(function(){
                newBenefit.element.css("background-color", "initial"); 
            }, 1000);
        }
    }

    function resizeBenefitWidth(){
        $(".perks__col.benefit").css("width","24.6%");
        $(".perks__col.benefit:nth-child(4n)").css("border-right","1px solid #f2e9dd");
        $(".perks__col.benefit:nth-child(5n)").css("border-right","none");
        $(".perks__col.benefit:lt(4)").css("border-bottom","1px solid #f2e9dd")
    }

    function resizeBenefitWidthRemove(){
        $(".perks__col.benefit").css("width","32.6%");
        $(".perks__col.benefit:nth-child(5n)").css("border-right","1px solid #f2e9dd");
        $(".perks__col.benefit:nth-child(4n)").css("border-right","none");
        $(".perks__col.benefit:lt(3)").css("border-bottom","1px solid #f2e9dd");
        $(".perks__col.benefit:nth-child(5n)").css("border-bottom","none")
    }

    $(".addBenefits").on('click', function(){
        // console.log("before add",count);
        
        if(count< mainBenefitsMaximum){
            if(count>5){
                addDynamicBenefit();
                resizeBenefitWidth();
                count++;
            }
            else{
                if(count == 3){
                    $('.perks__descriptive-perks-container').find(".perks__row").css("text-align", "center");
                    // $(".perks__container").find(".show-more-container.benefits").css("margin-top", "20px");
                    // $(".perks__container").find(".add-other-benefits").css("margin-top", "20px");
                }
                else{
                    $(".perks__col.benefit:nth-child(5n)").css("border-right","1px solid #f2e9dd");
                    $('.perks__descriptive-perks-container').find(".perks__row").css("text-align", "left");
                }
                addDynamicBenefit();
                $(".perks__col.benefit:lt(3)").css("border-bottom","1px solid #f2e9dd");
                count++; 
            }            
        }
        else{
            toastNotify(3,"You have acheived the maximum limit.");
        }
        // else{
        //     $(".perks__container").find(".show-more-container.benefits").removeClass("hidden");
        //     $(".perks__container").find(".perks__simple-perks-container").removeClass("hidden");
        //     // populateSimpleData(jsonData)
        //     addDynamicSimpleBenefit();
        //     count++;
        // }

        // console.log("after add", count);
        
    });  
    
    $(".add-simple-benefits").on('click', function(){
        if(othersCount< simpleBenefitsMaximum){
            $(".perks__container").find(".perks__simple-perks-container").removeClass("hidden");
            // populateSimpleData(jsonData)
            addDynamicSimpleBenefit();
            othersCount++;
        }
        else{
            toastNotify(3,"You have acheived the maximum limit.");
        }
    });

    $(".perks__row").on('click', ".removeBenefit" ,function(){  
        // console.log("clicked");
        if($(this).parent().hasClass('benefitSimple')){
            othersCount--;
            // console.log("others: ",othersCount);

            if(othersCount == 0){
                $(".perks__container").find(".perks__simple-perks-container").addClass("hidden");
            }
            
        }
        else{
            count--;   
            // console.log(count);

        }
        $(this).parent().remove();
        
             
        if(count<7){
            resizeBenefitWidthRemove();
            if(count<5){
                $('.perks__descriptive-perks-container').find(".perks__row").css("text-align", "center");
                $(".perks__col.benefit:nth-child(5n)").css("border-right","none");
            }
            if(count<4){
                $(".perks__col.benefit:lt(3)").css("border-bottom","none");
                // $(".perks__container").find(".show-more-container.benefits").css("margin-top", "40px");
                // $(".perks__container").find(".add-other-benefits").css("margin-top", "40px");
            }
        }
        // else if(count<9){
        //     $(".perks__container").find(".show-more-container").addClass("hidden");
        // }
    }); 

    populateData(jsonData);

    function showMoreBenefits(){          
        // if(count>8){
            showMoreContainer.removeClass("hidden");
            showMoreButton.html("See More");
            showMoreButton.append("<i class='icon-down_arrow'></i>");
        // }

        showMoreButton.on('click', function(){
            if($(".moreBenefit").hasClass("hidden")){
                // Remove hidden from simple container during preview
                $(".perks__container").find(".perks__simple-perks-container").removeClass("hidden");
                $(".moreBenefit").removeClass("hidden");
                // showMoreContainer.css("padding-bottom", "50px");
                showMoreButton.html("See Less");
                showMoreButton.append("<i class='icon-top_arrow'></i>");
            }
            else{
                $(".perks__container").find(".perks__simple-perks-container").addClass("hidden");
                $(".moreBenefit").addClass("hidden");
                // showMoreContainer.css("padding-bottom", "0");
                // showMoreButton.html("See Other " + $(".perks__col.benefitSimple").length + " Benefits");
                showMoreButton.html("See More");
                showMoreButton.append("<i class='icon-down_arrow'></i>");
            }
        });
    }

 
}

